import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal, LineReveal } from "../components/motion";
import CTABand from "../components/CTABand";
import { TestimonialCard } from "../components/TestimonialMarquee";
import { api } from "../lib/api";
import { useSEO, usePageView } from "../lib/seo";

export default function ParentStories() {
  const [testimonials, setTestimonials] = useState([]);

  useSEO({
    title: "Parent Stories — The Nanny Sleep Co.",
    description: "Real experiences from families who've worked with The Nanny Sleep Co. — organised by sleep challenge, from night wakes to toddler bedtimes.",
  });
  usePageView("/parent-stories");

  useEffect(() => {
    api.testimonials().then(setTestimonials).catch(() => {});
  }, []);

  return (
    <div data-testid="parent-stories-page">
      <section className="py-20 sm:py-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <p className="overline-label mb-5">Parent stories</p>
          <LineReveal
            className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight text-ink"
            lines={["You're not the only family", "awake tonight."]}
          />
          <Reveal delay={0.5}>
            <p className="mt-7 text-lg text-ink-soft leading-relaxed max-w-xl mx-auto">
              Words from families who've been exactly where you are — with the reminder that every child is different, and your journey will be your own.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 sm:pb-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {testimonials.map((t, i) => (
              <Reveal key={i} delay={(i % 4) * 0.08}>
                <div data-testid={`story-card-${i}`}>
                  <TestimonialCard t={t} className="!w-full h-full" />
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-14 text-center">
            <p className="text-ink-soft mb-6">Wondering what your family's story could look like?</p>
            <Link to="/book-a-call" data-testid="stories-book-cta" className="btn-primary">Talk through your situation</Link>
          </Reveal>
        </div>
      </section>

      <CTABand title="Every story starts the same way — exhausted" body="And most start small: five gentle questions, or one free 15-minute conversation. No obligation either way." />
    </div>
  );
}
